function toggleVideoFullscreen(videoId, videoToSet, videoFullscreen) {
  const stopBtn = document.getElementById(`stopVideo--${videoId}`);
  const buttonWrapper = document.querySelector(`.wrapper-button--${videoId}`)
  const wrapper = document.getElementById(`videoWrapper--${videoId}`);
  const videoWrapper = document.getElementById(`videoContainer--${videoId}`)
  if(document.querySelector(`.stories-upsell--${videoId}`)){
    const productUpsell = document.querySelector(`.stories-upsell--${videoId}`)
    productUpsell?.classList.toggle("hidden-block")
  }
  buttonWrapper.classList.toggle("button-border")
  if(videoToSet && !videoFullscreen){
    videoWrapper.innerHTML = `
        <video
          id="videoPlayer--${videoId}"
          class=""
          playsinline
          preload="none"
          muted
          autoplay
          loop
        >
          <source src="${videoToSet}" type="video/mp4">
        </video>
      `;
  }
  stopBtn.classList.toggle("hidden-block");
  wrapper.classList.toggle("hidden-block");
}


function handleVideoFullscreen(videoId, buttonValue, videoToSetDesktop , videoToSetMobile) {
  let videoToSet = videoToSetDesktop;
  const videoFullscreen = document.getElementById(`videoPlayer--${videoId}`);
  const header = document.querySelector(".section-header");
  const brandsHeader = document.querySelector(".shopify-section-group-header-group");
  const body = document.body;
  if(videoToSetMobile){
    videoToSet = window.innerWidth > 768 ? videoToSet : videoToSetMobile;
  }
  if (buttonValue === "play") {
    body.classList.add("overflow-hidden");
    brandsHeader?.classList.add("fixed");
    brandsHeader?.classList.add("hidden-block");
    header?.classList.add("fixed");

    toggleVideoFullscreen(videoId, videoToSet, videoFullscreen);
    if(videoFullscreen){
      videoFullscreen.muted = false;
      videoFullscreen.currentTime = 0;
      videoFullscreen.play();
    }
  };

  if (buttonValue === "stop") {
    body.classList.remove("overflow-hidden");
    brandsHeader?.classList.remove("fixed");
    brandsHeader?.classList.remove("hidden-block");
    header?.classList.remove("fixed");

    videoFullscreen.muted = true;
    videoFullscreen.pause();
    toggleVideoFullscreen(videoId, videoToSet, videoFullscreen);
  };
}